export default "__VITE_ASSET__2453756e__"